import React from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from '@chakra-ui/react'

// Tooltip styled per the design system: white surface, soft neutral shadow,
// no arrow. Shown on hover over the collapsed nav rail and the product rail,
// where labels are otherwise hidden.
const NavTooltip = ({label, placement, children}) => (
  <Tooltip
    label={label}
    placement={placement}
    hasArrow={false}
    bg="mld.neutral.0"
    color="mld.neutral.1000"
    fontSize="14px"
    letterSpacing="-0.14px"
    lineHeight="1.25"
    borderRadius="4px"
    px="20px"
    py="18px"
    boxShadow="2px 4px 8px 0px var(--chakra-colors-mld-neutral-200)"
  >
    {children}
  </Tooltip>
)

NavTooltip.propTypes = {
  label: PropTypes.node.isRequired,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
}

NavTooltip.defaultProps = {placement: 'right'}

export default NavTooltip
